// extracted by mini-css-extract-plugin
export var wrapper = "Clients-module--wrapper--vRrqq";